import { userAppPreferencesDefault } from '../../data/user-app-preferences-default';
import {
    UserAppPreferencesModel
} from '../../models/user-app-preferences.model';

/**
 * Merged accessibilityPrefs into generalPrefs
 */
export function fromOnePointFiveToOnePointSeven(oldDataModel: UserAppPreferencesModel): UserAppPreferencesModel {
    const newModel = new UserAppPreferencesModel();
    newModel.version = '1.7';
    newModel.reportsPrefs = oldDataModel.reportsPrefs;
    newModel.targetingPrefs = oldDataModel.targetingPrefs;
    newModel.monitoringPrefs = oldDataModel.monitoringPrefs;

    if (!newModel.contactsPrefs) {
        newModel.contactsPrefs = userAppPreferencesDefault.contactsPrefs;
    }

    newModel.socialPrefs = oldDataModel.socialPrefs;

    newModel.generalPrefs= {
        favoriteColors: oldDataModel?.generalPrefs?.favoriteColors ?? userAppPreferencesDefault.generalPrefs.favoriteColors,
        accessibility: oldDataModel?.generalPrefs?.accessibility ?? userAppPreferencesDefault.generalPrefs.accessibility
    };

    if (oldDataModel?.accessibilityPrefs) {
        newModel.generalPrefs.accessibility = oldDataModel.accessibilityPrefs;
        delete oldDataModel.accessibilityPrefs;
    }
    return newModel;
}
